
export default {
  meta: {
    seo: {
      title: 'pages.menu',
      description: 'menuPage.excerpt'
    }
  },
  layout({ query }) {
    if (query.source == 'qrcode') {
      return 'catalog'
    }
  },
  async asyncData ({ $content, params, query, app: { i18n: { locale } } }) {
    const id = params.id || 'the-babaaurums-classics'
    const qrcode = query.source == 'qrcode'

    const category = await $content(locale, 'menus', id)
      .only(['name', 'slug', 'excerpt', 'image'])
      .fetch()

    return { category, qrcode }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    const id = this.$route.params.id || 'the-babaaurums-classics'

    this.category = await $content(locale, 'menus', id)
      .only(['name', 'slug', 'excerpt', 'image'])
      .fetch()
  },
  watch: {
    '$route.params.id': {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.$fetch()
        }
      }
    }
  },
  data() {
    return {
      title: this.$t('pages.menu')
    }
  },
  computed: {
    image() {
      return {
        source: this.category.image.src,
        ratio: null,
        fit: 'contain',
        position: 'center',
        height: '4xl'
      }
    }
  }
}
